import { FormOption } from '@domgen/dgx-fe-forms/shared';
import { addDays, format, startOfMonth } from 'date-fns';

export const directDebitPaymentDateOptions: FormOption[] = Array.from(
  { length: 28 },
  (_, index: number) => {
    const date: Date = addDays(startOfMonth(new Date()), index);

    return {
      label: format(date, 'do'),
      value: index + 1,
    };
  }
);
